import styled from "styled-components";

export const Styles = styled.div`
  margin-bottom: 3rem;

  table {
    table-layout: fixed;
    border-spacing: 0;
    border: 1px solid #e9e9e9;
    &.react-table-submitted,
    &.react-table-historical {
      td,
      th {
        &:last-child {
          width: 2%;
        }
      }
    }
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th {
      background-color: #f7f7f7;
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #e9e9e9;
      border-right: 1px solid #e9e9e9;
    }
  }
`;

export const TH = styled.th`
  padding: 0 !important;
`;

export const TD = styled.td`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;

  width: 16%;

  &.checkbox {
    width: 2%;
  }
  &.notificationDate {
    width: 8%;
  }
  &.caseNumber {
    width: 10%;
  }
  &.visaType {
    width: 5%;
  }
  &.jobTitle {
    width: 10%;
  }
  &.caseDetails {
    width: 5.5%;
  }

  ${(props) =>
    props.loader &&
    `
    background-color: #f7f7f7;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #e9e9e9;
  `}
`;

export const TDIcon = styled.div`
  color: red;
  cursor: pointer;
  transition: all 0.25s;
  &:hover {
    opacity: 0.75;
  }
  svg {
    float: left;
    width: 38px;
  }
`;

export const TH_Container = styled.div`
  padding: 0.5rem;
  display: flex;
  justify-content: space-between;
  ${(props) => props.isSorted && `background-color: #efefef`}
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;

  .input-page {
    margin: 0 2rem;
  }

  select {
    margin-left: 1rem;
  }
`;

export const PageNavButton = styled.button`
  background-color: #f7fafd;
  border: 1px solid white;
  border-radius: 5px;
  color: #7fa1c8;
  height: 34px;
  width: 34px;
  padding: 0;

  &:hover:enabled {
    color: #7fa1c8;
    background-color: #e4f0fb;
  }

  &:disabled {
    background-color: #f7f7f7;
    cursor: not-allowed;
    color: lightgray;
  }
`;

export const PageInput = styled.input`
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 5px 7px;
  font-size: inherit;
  border-radius: 3px;
  font-weight: normal;
  outline: none;
  width: 60px;
  text-align: center;
`;

export const ActionButton = styled.button`
  border-color: #498fc8;
  color: #2d71bc;
  background-color: white;
  padding: 4px 9px;
  border-radius: 4px;
  border: 2px solid #2d71bc;
  transition: all 0.25s;
  position: absolute;
  float: left;
  &:hover {
    color: #ffffff;
    background-color: #2d71bc;
  }
  &:disabled {
    background-color: #f7f7f7;
    border: 2px solid #f7f7f7;
    cursor: not-allowed;
    color: lightgray;
  }
`;

export const NotificationCounter = styled.div`
  margin-bottom: 20px;
  font-size: 0.8rem;
  font-weight: bold;
  color: #5b616b;
  text-transform: uppercase;
`;

export const SubComponent = styled.div`

  border-top: 1px solid #e9e9e9;
  border-left: 5px solid #e9e9e9;
  background: #f7f7f7;
  padding: 0 0 1rem 2.5rem;
  button {
    svg {
      position: relative;
      font-size: .8rem;
    }
  }


	.column-align{
		margin: 20px 0;
	
	.left-align{
		text-align: left;
		margin-right:10px;
		p{
			margin: 5px 0;
		
		}
		.expand-edit-btn{
			margin-top: 10px;
		}

	}
	.right-align{
		text-align:right;
		p{
			font-weight: 700;
			margin: 5px 0;
			margin-right: 10px;
		}
	}
`;

export const StatusPill = styled.div`
  text-transform: uppercase;
  border-radius: 2px;
  width: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;

  // default
  background: #f1f1f1;
  font-weight: bold;
  font-size: 0.8rem;
  text-align: center;
  color: #000;
  border: 1px solid #aeb0b5;

  ${(props) =>
    (props.status === "in-process" || props.status === "pending-processing") &&
    `
  background:  #e1f3f8;
  border: 1px solid  #03bfe7;
  `}

  ${(props) =>
    props.status === "initiated" &&
    `
  background: #fff1d2;
  border: 1px solid #fdb81e;
  `}

span {
    padding: 4px;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
